import { AccessDenied } from '@core/ui';
import { Trans } from 'react-i18next';

export const DuplicateSession = () => {
    return <div className="flex-1 max-w-4xl flex flex-col items-center justify-center mx-auto px-4 py-8 md:px-8 lg:px-12 text-center">
        <AccessDenied classNames="w-10 md:w-12 lg:w-16 stroke-warning mb-4" />
        <p><Trans i18nKey="Viewer.Message.MultipleSessions" /></p>
    </div>;
};
